import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateBatch } from '@components/settings/actions';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui';
import VisuallyHiddenLegend from '@shared/visually-hidden-legend';
import UnstyledHeading from '@shared/unstyled-heading';
import './settings.scss';

const Batch = () => {
  const { global: { batch } } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const onChange = event => dispatch(updateBatch(event.target.value));

  return (
    <div styleName="settings-form-container">
      <div styleName="title">
        <UnstyledHeading rank={2}>
          <div styleName="text">Batch</div>
        </UnstyledHeading>
      </div>
      <div styleName="hint">
        Switch between the old and new batch design.
      </div>
      <div styleName="form">
        <FormControl component="fieldset">
          <VisuallyHiddenLegend>Batch</VisuallyHiddenLegend>
          <RadioGroup aria-label="batch" name="batch" value={batch} onChange={onChange}>
            <FormControlLabel value="old" control={<Radio color="primary" />} label="Old Batch Design" />
            <FormControlLabel value="default" control={<Radio color="primary" />} label="New Batch Design" />
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};

export default memo(Batch);
